import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase/client';

export interface InviteInfo {
  email: string;
  full_name: string;
  role: string;
  invite_status: string;
  invite_expires_at: string | null;
  b2b_company_id: string;
  company_name: string;
  product_name: string | null;
  logo_url: string | null;
  portal_url: string | null;
}

async function fetchInvite(token: string): Promise<InviteInfo | null> {
  const { data, error } = await supabase.rpc(
    'get_b2b_invite_info' as never,
    {
      p_token: token,
    } as never
  );
  if (error) throw new Error(`invite lookup: ${error.message}`);
  const rows = (data ?? []) as InviteInfo[];
  return rows[0] ?? null;
}

export function useInviteLookup(token: string) {
  return useQuery({
    queryKey: ['neurax', 'invite-lookup', token],
    queryFn: () => fetchInvite(token),
    enabled: Boolean(token),
    staleTime: 60_000,
    retry: false,
  });
}
